import { distinctUntilChanged, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as R from 'ramda'
import * as RE from 'helpers/ramda-ext'
import * as Actions from 'store/actions/index.ts'
import {
  getBeginDate,
  getCities,
  getDepartureCitiesFiltersFromReducer,
  getFilteredProductsInParentScope,
  getFiltersProducts,
  getHasDepartureDateFlexibilityBeenUsed,
  getNbFilteredProductsReferences,
  getNbFilteredProductsWithTags,
  getQueryFiltersParams,
  getSelectedDepartureDatesSettings,
  getSelectedDurationsFiltersFromReducer
} from 'store/selectors'
import { track } from 'tracking/mixPanel'
import { DATE_FILTERS_FORMAT } from 'constants/dateFormats'
import { getDepartureDatesFromOffset } from 'domain/filters'
import { getDepartureCitiesFromCode } from 'domain/pricerDepartureCity'
import { mapStateToMPEvent as getViewCatalogPageData } from './viewCatalogPage'

const mapStateToMPEvent = (eventName, state) => {
  const amountOfFilteredProducts = getNbFilteredProductsReferences(state)
  const amountOfFilteredProductsWithStressMarketing = getNbFilteredProductsWithTags(state)
  const beginDate = getBeginDate(state)

  const citiesList = getCities(state)
  const departureCitiesFilters = getDepartureCitiesFiltersFromReducer(state)
  const departureCities = getDepartureCitiesFromCode(citiesList)(departureCitiesFilters)

  const durationsFilters = getSelectedDurationsFiltersFromReducer(state)
  const durations = durationsFilters.map(durations => `${durations} nights`)

  const [departureDateOffset, departureDateFlexibility] = getSelectedDepartureDatesSettings(state)
  const departureDates = getDepartureDatesFromOffset(beginDate, DATE_FILTERS_FORMAT)([departureDateOffset])
  const hasDepartureDateFlexibilityBeenUsed = getHasDepartureDateFlexibilityBeenUsed(state)
  const dateFlexibility = hasDepartureDateFlexibilityBeenUsed ? departureDateFlexibility : undefined

  const queryFiltersParams = getQueryFiltersParams(state)
  const filtersProducts = getFiltersProducts(state)
  const products = getFilteredProductsInParentScope(state)

  const hasMoreOffers = (Object.keys(filtersProducts).length > 0)
  const hasNoProducts = RE.isNotEmpty(queryFiltersParams) && !R.length(products)

  return {
    ...getViewCatalogPageData(eventName, state),
    '# of Filtered products': amountOfFilteredProducts,
    '# of Filtered products with stress marketing': amountOfFilteredProductsWithStressMarketing,
    'Date Flexibility': dateFlexibility,
    'Filter City': departureCities,
    'Filter City On': Boolean(departureCities.length),
    'Filter Date': departureDates,
    'Filter Date On': Boolean(departureDates.length),
    'Filter Duration': durations,
    'Filter Duration On': Boolean(durations.length),
    'No Filters Result': hasNoProducts && !hasMoreOffers,
    'Page Name': 'Catalogue Page'
  }
}

const filtersViewFilteredCatalogEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(Actions.filters.FILTERS_FETCHED),
  distinctUntilChanged(),
  tap(() => {
    const eventName = 'View filtered catalogue page'

    track(
      eventName,
      mapStateToMPEvent(eventName, state$.value),
      { debug: !__PRODUCTION__ }
    )
  }),
  ignoreElements()
)

export default filtersViewFilteredCatalogEpic
